module.exports = __webpack_public_path__ + "img/dumptruck-vector.16ecbb58.png";